import React, { Component } from 'react';
import {isEmptyVariable,isEmptyArray} from '../Global/commonFunctions';
import {Dropdown} from 'react-bootstrap';
import {TreeNodeDropdownIcon} from '../Global/globalStyles.style'

class TreeNodeDropdown extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
    }

    componentDidUpdate(){
    }

    dropDownItemClick = (item,e) => {
        e.stopPropagation();
        this.props.onDropDownItemClick(item,this.props.dropdownId);
    }

    render(){
        let marginTop = this.props.pMarginTop || '3px';
        let clauseHeadingSplit = this.props?.placeholder?.split(":");
        let clauseName = clauseHeadingSplit[0] ? clauseHeadingSplit[0] : "";
        let heading = clauseHeadingSplit[1] ? clauseHeadingSplit[1] : "";
        let displayPlaceholder = `${clauseName}<p style="white-space:nowrap;margin-top: ${marginTop};">&nbsp;:&nbsp;</p>${heading}`;
        return(
            <div className="regular-dropdown-layout tree-node-dropdown">
            <Dropdown drop={"right"}>
                <div className='d-flex'>
                    <div style={{width:"100%"}}>
                        {this.props.rootNode ? 
                            <Dropdown.Toggle id="dropdown-basic" className={this.props.className?this.props.className:""}>
                                <p 
                                    style={{color:this.props.fontColor,marginTop:this.props.paraMT?this.props.paraMT:0}}
                                    className={this.props.fontbold?"placeholder-text font-bold":"placeholder-text"}
                                >
                                    {this.props.placeholder}
                                </p>
                            </Dropdown.Toggle>
                        :
                            <Dropdown.Toggle id="dropdown-basic" className={this.props.className?this.props.className:""}>
                                <p 
                                    style={{color:this.props.fontColor,marginTop:this.props.paraMT?this.props.paraMT:0, marginBottom:3}}
                                    className='task-dangerouslysethtml inner-html d-flex'
                                    dangerouslySetInnerHTML={{__html: displayPlaceholder}}></p>
                                {/* <span className="material-icons">expand_more</span> */}
                            </Dropdown.Toggle>
                        }
                        {/* Below description props is used for framework  */}
                        {this.props.description &&
                            <div style={{
                                    marginTop:4,
                                    marginBottom:12,
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    overflow: "visible",
                                }}
                                className='task-dangerouslysethtml inner-html' dangerouslySetInnerHTML={{__html: this.props.description}} 
                            />
                        }
                    </div>
                    {/* Below span tag is used for framework  */}
                    <span className="tool" data-title="Link">
                        {!isEmptyVariable(this.props.dropdownId?.versionControl) &&
                            <span className="material-symbols-outlined" onClick={() => this.props.handleOnClick()}>conversion_path</span>
                        }
                    </span>
                </div>
                {
                    !isEmptyVariable(this.props.dropdownArr) &&
                    !isEmptyArray(this.props.dropdownArr) &&
                    <Dropdown.Menu>
                    {
                        !isEmptyVariable(this.props.dropdownArr) &&
                        this.props.dropdownArr.map((item)=>{
                            return <Dropdown.Item onClick={this.dropDownItemClick.bind(this,item)} href="javascript:void(0)">
                                <TreeNodeDropdownIcon
                                themeSettings={this.props.themeSettings}
                                className="material-icons">{item.icon}</TreeNodeDropdownIcon> 
                                <p className="dropdown-text">{item[this.props.labelParam]}</p>
                            </Dropdown.Item>
                        })
                    }
                    </Dropdown.Menu>
                }
            </Dropdown>
            </div>
        )
    }
}

export default TreeNodeDropdown;